/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { ESRMainComponent} from './ESR_main.component';
import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { CESP } from '../_common/data/input-data';

export class ESRMainValidation extends IValidator {

      private viewportScroller:ViewportScroller;

       constructor(private component: ESRMainComponent) {
             super();
             this.viewportScroller = this.component.viewportScroller;
             //this.CESP.backup( this.component.data.CESP );
       }

       private CESP:CESP = new CESP();
       private success: boolean;

       public validate(): boolean {

            this.success = true;           
       
            if ( Util.isEmptyNumber(this.component.data.CESP.contactParent) || this.component.data.CESP.contactParent == -1 ) {
                  this.focus('selParent','radio_certifyingParentsRadio_0').error_noParent = "ESR_main.errNoParent"; 
            }
            
            if ( Util.isEmpty(this.component.data.CESP.category)) {
                  this.focus('category','select_categorySelect').error_category = "ESR_main.errCategory"; 
            }
            
            if ( Util.isEmpty(this.component.data.CESP.promoter) ) {
                  this.focus('promoter','select_promoterSelect').error_promoter = "ESR_main.errSelToHear"; 
            }
            
            if ( Util.isEmpty(this.component.data.CESP.postalCode)) {
                  this.focus('locate','input_postalCodeInput').error_postalCode = "ESR_main.errPostalCodeEmpty"; 
            }
            else if ( !Util.postalCodeGlobalValidate(this.component.data.CESP.postalCode)) {
                  this.focus('locate','input_postalCodeInput').error_postalCode = "ESR_main.errPostalCodeInvalid"; 
            }
            
            if ( Util.isEmpty(this.component.data.CESP.country)) {
                  this.focus('locate','input_countryInput').error_country = "ESR_main.errCountryEmpty"; 
            }else if ( Util.hasSpecialCharacter(this.component.data.CESP.country)) {
                  this.focus('locate','input_countryInput').error_country = "ESR_main.errCountryInvalid"; 
            }
            
            if ( Util.isEmpty(this.component.data.CESP.contactMethod)) {
                  this.focus('method','radio_methodRadio_0').error_contactMethod = "ESR_main.errContactMethod"; 
            }
            
            if ( this.component.data.CESP.contactMethod == '2'){
                  if(Util.isEmpty(this.component.data.CESP.contactEmail)) {
                        this.focus('method','input_emailInput').error_email = "ESR_main.errEmailEmpty"; 
                  }else if ( !Util.emailValidate(this.component.data.CESP.contactEmail)) {
                        this.focus('method','input_emailInput').error_email = "ESR_main.errEmailInvalid"; 
                  }
            }
            
            if ( this.component.data.CESP.contactMethod == '1') { 
                        if(Util.isEmpty(this.component.data.CESP.firstArea)
                              || Util.isEmpty(this.component.data.CESP.firstNumber1)
                              || Util.isEmpty(this.component.data.CESP.firstNumber2)) {
                        this.focus('method','input_areaCodeInput').error_phoneNumber = "ESR_main.phoneNumberEmpty"; 
                  }else if(!Util.isNumeric(this.component.data.CESP.firstArea)
                              || !Util.isNumeric(this.component.data.CESP.firstNumber1)
                              || !Util.isNumeric(this.component.data.CESP.firstNumber2)
                              || this.component.data.CESP.firstArea.length != 3
                              || this.component.data.CESP.firstNumber1.length != 3
                              || this.component.data.CESP.firstNumber2.length != 4){
                        this.focus('method','input_areaCodeInput').error_phoneNumber = "ESR_main.phoneNumberInvalid";                  
                  }
                  
                  if ( (!Util.isEmpty(this.component.data.CESP.secondArea) 
                              && (!Util.isNumeric(this.component.data.CESP.secondArea) || this.component.data.CESP.secondArea.length != 3))
                        || (!Util.isEmpty(this.component.data.CESP.secondNumber1) 
                              && (!Util.isNumeric(this.component.data.CESP.secondNumber1) || this.component.data.CESP.secondNumber1.length != 3))
                        || (!Util.isEmpty(this.component.data.CESP.secondNumber2) 
                              && (!Util.isNumeric(this.component.data.CESP.secondNumber2) || this.component.data.CESP.secondNumber2.length != 4))){
                              
                        this.focus('method','input_areaCodeSecInput').error_phoneNumber = "ESR_main.phoneNumberInvalid";
                        
                  }
                  
                  if(!Util.isEmpty(this.component.data.CESP.firstExt)
                              && !Util.isNumeric(this.component.data.CESP.firstExt)){
                        this.jump('method').error_phoneNumber = "ESR_main.extensionInvalid";
                  }
                  
                  if(!Util.isEmpty(this.component.data.CESP.secondExt)
                              && !Util.isNumeric(this.component.data.CESP.secondExt)){
                        this.jump('method').error_phoneNumber = "ESR_main.extensionSecInvalid";
                  }
            }
            
            
            
            if ( !this.component.data.CESP.chk_privacy ) {
                  this.focus('privacy','chkbox_privacyCheckbox').error_notice = "ESR_main.chk_notice_error"; 
            }
            
            if ( !this.component.data.CESP.chk_disclaimer ) {
                  this.focus('disclaimer','chkbox_disclaimerCheckbox').error_disclaimer = "ESR_main.chk_disclaimer_error"; 
            }
            
            if ( !this.component.data.CESP.chk_consent ) {
                  this.focus('consent','chkbox_consentCheckbox').error_consent = "ESR_main.chk_consent_error"; 
            }
            
            if ( !this.component.data.CESP.chk_disclosure ) {
                  this.focus('consent','chkbox_disclosureCheckbox').error_disclosure = "ESR_main.errFinalCB"; 
            }

            return this.success;
       }

       public setConsentError(){
            return this.component.error_consent = "ESR_main.chk_consent_error";
       }

       public setDisclaimerError(){
            return this.component.error_disclaimer = "ESR_main.chk_disclaimer_error";
       }
       
       private jump(tagId:string) : ESRMainComponent {
               if ( this.success )
                    this.viewportScroller.scrollToAnchor(tagId);
               this.success = false;
               return this.component;
       }

       private focus(tagId:string,ctrlId:string) : ESRMainComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

       /**
       public IdOfChanged():number { 
            let inputCESP:CESP = this.component.data.CESP;
            if ( this.CESP.contactParent != inputCESP.contactParent 
              || this.CESP.promoter != inputCESP.promoter 
              || this.CESP.chk_consent != inputCESP.chk_consent 
              || this.CESP.postalCode != inputCESP.postalCode 
              || this.CESP.country != inputCESP.country 

              || this.CESP.contactLang != inputCESP.contactLang 
              || this.CESP.contactMethod != inputCESP.contactMethod 
              || this.CESP.contactEmail != inputCESP.contactEmail 

              || this.CESP.firstArea != inputCESP.firstArea 
              || this.CESP.firstNumber1 != inputCESP.firstNumber1 
              || this.CESP.firstNumber2 != inputCESP.firstNumber2 
              || this.CESP.firstExt != inputCESP.firstExt 
              || this.CESP.firstTTY != inputCESP.firstTTY 

              || this.CESP.secondArea != inputCESP.secondArea 
              || this.CESP.secondNumber1 != inputCESP.secondNumber1 
              || this.CESP.secondNumber2 != inputCESP.secondNumber2 
              || this.CESP.secondExt != inputCESP.secondExt 
              || this.CESP.secondTTY != inputCESP.secondTTY 

              || this.CESP.contactTime != inputCESP.contactTime 
              || this.CESP.category != inputCESP.category 
              || this.CESP.chk_disclaimer != inputCESP.chk_disclaimer 
              || this.CESP.chk_privacy != inputCESP.chk_privacy 
              || this.CESP.chk_disclosure != inputCESP.chk_disclosure 
               ) return this.menuID;
            return 0;
       }
        */
}
